"use strict";

exports.__esModule = true;
exports.StripeChartThumbnail = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _PlantStateActivities = require("../../PlantStateActivities");
var _class, _StripeChartThumbnail;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function createState(props) {
  var width = props.width,
    height = props.height,
    theme = props.theme;
  var plantStateColors = (0, _PlantStateActivities.getPlantStateColors)(theme);
  var stateIds = Object.keys(plantStateColors);
  var totalStripes = Math.floor(Math.random() * 100);
  var stripes = [];
  var currentX = 0;
  for (var currentIndex = 0; currentIndex < totalStripes; currentIndex++) {
    var stripeSize = Math.min(Math.ceil(Math.random() * 20), totalStripes - currentIndex);
    var stripeWidth = Math.floor(stripeSize * (width / totalStripes));
    var stateId = stateIds[Math.floor(Math.random() * stateIds.length)];
    var fill = plantStateColors[stateId];
    stripes.push(/*#__PURE__*/_react["default"].createElement("rect", {
      key: String(currentIndex),
      fill: fill,
      x: currentX,
      y: 0,
      height: height,
      width: stripeWidth
    }));
    currentX += stripeWidth;
    currentIndex += stripeSize;
  }
  return {
    width: width,
    height: height,
    stripes: stripes
  };
}

/**
 * Thumbnail for StripeChartWidget.
 */
var StripeChartThumbnail = exports.StripeChartThumbnail = (0, _styledComponents.withTheme)(_class = (_StripeChartThumbnail = /*#__PURE__*/function (_React$PureComponent) {
  function StripeChartThumbnail() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = createState(_this.props);
    return _this;
  }
  _inheritsLoose(StripeChartThumbnail, _React$PureComponent);
  StripeChartThumbnail.getDerivedStateFromProps = function getDerivedStateFromProps(props, prevState) {
    if (props.width === prevState.width && props.height === prevState.height) {
      return null;
    }
    return createState(props);
  };
  var _proto = StripeChartThumbnail.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      x = _this$props.x,
      y = _this$props.y,
      width = _this$props.width,
      height = _this$props.height;
    var stripes = this.state.stripes;
    return /*#__PURE__*/_react["default"].createElement("svg", {
      x: x,
      y: y,
      width: width,
      height: height
    }, stripes);
  };
  return StripeChartThumbnail;
}(_react["default"].PureComponent), _StripeChartThumbnail.defaultProps = {
  x: 0,
  y: 0,
  theme: undefined
}, _StripeChartThumbnail)) || _class;